import { Route } from 'vue-router'

import { Component, Options } from '../../types/middleware.d'

const getComponentOptions = (component: Component, optionKey: keyof Options) => {
  if (process.client) {
    return component.options[optionKey] || []
  }

  const { _Ctor: ctor } = component

  const componentOptions = Object.values(ctor).reduce<string[]>((currentComponentOptions, value) => {
    if (!value.options || !value.options[optionKey]) {
      return currentComponentOptions
    }

    // If we want the options keys to be optional, we need to send an empty array
    const availableComponentOptions = value.options[optionKey] || []

    return [...currentComponentOptions, ...availableComponentOptions]
  }, [])

  return componentOptions
}

export const getOptions = ({ matched }: Route, optionKey: keyof Options) => {
  const options = matched.reduce<string[]>((currentOptions, { components }) => {
    if (!components) {
      return currentOptions
    }

    const matchedOptions = Object.values(components).reduce<string[]>((currentComponentOptions, component) => {
      const componentOptions = getComponentOptions(component as Component, optionKey)

      return [...currentComponentOptions, ...componentOptions]
    }, [])

    return [...currentOptions, ...matchedOptions]
  }, [])

  return options
}
